import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ztcgjiaoyijilu} from '../../action/investmentAction';
import {Picker, List,  ListView } from 'antd-mobile/lib';
import '../nheaderjiaoyijilu.css'
import '../css/Transferrecord.css'
import { hashHistory } from "react-router";
import Util from '../../util.js';
var objArr;

/*产品交易记录*/
class Transactionrecordztgz extends Component {
  constructor(props) {
    super(props);
    let ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});

    this.state = {
      isLoading:true,
      dataSource:ds.cloneWithRows([]),
      height:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1?window.winHeight:window.winHeight - 88,
      businessType:"",
      fundCode:"",
      pageIndex:1,
      pageSize:30,
      totalDataArr:[],
      transactionAll:false,
      timeAll:false,
      txt:"类型",
      transactionType:'全部类型',
      period:"全部时间",
      periodType: "",
      nomore:false,
    };
  }
  componentWillMount(){
    objArr = [];
  }
  componentDidUpdate(){
  }
  callbackData(data){
    console.log(data,"交易记录记录记录")
    let totalDataArr = this.state.totalDataArr.concat(data.records);
    if(data.records.length !== 0){
      if(data.records.length < this.state.pageSize){
        this.setState({
          nomore:3,
          dataSource: this.state.dataSource.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          pageIndex: this.state.pageIndex+1,
          loadingFlag:false,
          handleFlag:false,
          timeAll:false,
        })
      }else{
        this.setState({
          nomore:0,
          pageIndex: this.state.pageIndex+1,
          dataSource:this.state.dataSource.cloneWithRows(totalDataArr),
          totalDataArr:totalDataArr,
          loadingFlag:false,
          handleFlag:false,
      timeAll:false,
        })
      }
    }else{
      this.setState({
        nomore:3,
        loadingFlag:false,
      timeAll:false,
      })
    }
  }
  componentDidMount(){
    let { dispatch } = this.props;
    console.log(this.state.period,this.state.transactionType)
    let period=this.state.period
    let transactionType=this.state.transactionType
    sessionStorage.setItem('period',period)
    sessionStorage.setItem('transactionType',transactionType)
    let _this = this;
    let data1 = {
      pageIndex:this.state.pageIndex,
      pageSize:this.state.pageSize,
      superFundCode:this.props.location.state.superFundCode,
  }
  dispatch(ztcgjiaoyijilu(data1,this.callbackData.bind(this),_this))

  }
  
  goBack = () => {
    hashHistory.goBack();
  };
  getSource = () => {
    let { dispatch,  isRealName } = this.props;
    let _this = this;
    let data = {
      pageIndex:this.state.pageIndex,
      pageSize:this.state.pageSize,
      businessType:this.state.businessType,
      superFundCode:this.props.location.state.superFundCode,

    }
      dispatch(ztcgjiaoyijilu(data,this.callbackData.bind(this),_this))
  }

  timeTypeCallback(period,periodType){
    let _this = this;
    let flag;
    if(this.state.totalDataArr.length !== 0){
      flag = true;
    }else{
      flag = false;
    }
    let { dispatch } = this.props;
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});

    this.setState({
      loadingFlag:flag,
      period:period,
      periodType:periodType,
      pageIndex:1,
      pageSize:30,
      totalDataArr:[],
      handleFlag:true,
      timeAll:false,
      dataSource:ds.cloneWithRows([]),
    })
    let data = {
        pageIndex:1,
        pageSize:30,
        periodType:periodType,
        businessType:this.state.businessType,
        superFundCode:this.props.location.state.superFundCode,
    }
    dispatch(ztcgjiaoyijilu(data,this.callbackData.bind(this),_this))
  }
  jyTypeCallback(transactionType,businessType){
    let _this = this;
    let flag;
    if(this.state.totalDataArr.length !== 0){
      flag = true;
    }else{
      flag = false;
    }
    let { dispatch } = this.props;
    const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});

    this.setState({
      loadingFlag:flag,
      transactionAll:false,
      transactionType:transactionType,
      businessType:businessType,
      pageIndex:1,
      pageSize:30,
      totalDataArr:[],
      handleFlag:true,
      timeAll:false,
      dataSource:ds.cloneWithRows([]),
    })
    let data = {
        pageIndex:1,
        pageSize:30,
        periodType:this.state.periodType,
        businessType:businessType,
        superFundCode:this.props.location.state.superFundCode,
    }
    dispatch(ztcgjiaoyijilu(data,this.callbackData.bind(this),_this))
  }

  renderFooter(){
    if(this.state.nomore === 3){
      if(this.state.totalDataArr.length === 0){
        return(
          <div style={{ height: 0, textAlign: 'center' }}>
          没有更多数据了
       </div>
        )
      }else{
        return (
          <div style={{height:0, textAlign: 'center' }}>
       </div>
        );
      }
    }else {
      return null;
    }
  }

  selectLeft(txt){
    this.setState({
      transactionAll: !this.state.transactionAll,
      timeAll:false,
      txt:txt
    })
  }
  selectRight(txt){
    this.setState({
      timeAll:!this.state.timeAll,
      transactionAll:false,
      txt:txt
    })
  }
  detailPush(annualizedGains,dividendMethod,confirmVolume,confirmAmount,redeemRate,commission,trustChannelName,fundName,superFundName,confirmTimeStr,businessTimeStr,applicationAmount,tradeRequestId,businessType){
    let data = {
      tradeRequestId:tradeRequestId,
      businessType:businessType
    }

      if(businessType === "T522" || businessType === "T822" || businessType === "T422"){ //银行卡、零钱宝、活期通申购
        hashHistory.push({
          pathname:"/Transferinrecord",
          state:{
              commission:commission,
              confirmTimeStr:confirmTimeStr,
              businessTimeStr:businessTimeStr,
              applicationAmount:applicationAmount,
              tradeRequestId:tradeRequestId,
            }
          });
      }else if(businessType === "T024" || businessType === "TA24" || businessType === "TF24"){ //赎回至银行卡、零钱宝、活期通
        hashHistory.push({
          pathname:"/Transferrecord",
          state:{
              annualizedGains:annualizedGains,
              confirmAmount:confirmAmount,
              redeemRate:redeemRate,
              commission:commission,
              confirmTimeStr:confirmTimeStr,
              businessTimeStr:businessTimeStr,
              applicationAmount:applicationAmount,
              tradeRequestId:tradeRequestId,
              superFundCode:this.props.location.state.superFundCode
            }
          });
      }else if(businessType === "T031"){ //分红   //因为列表里的数据完全满足了分红的需求并且从详情里面取会特别麻烦所以数据是从列表带的
        hashHistory.push({
          pathname:"/Dividendreinvestedincash",
          state:{
              confirmVolume:confirmVolume,
              dividendMethod:dividendMethod,
              confirmAmount:confirmAmount,
              trustChannelName:trustChannelName,
              fundName:fundName,
              superFundName:superFundName,
              confirmTimeStr:confirmTimeStr,
              tradeRequestId:tradeRequestId,
            }
          });
      }else if(businessType === "T999"){ //调仓
        hashHistory.push({
          pathname:"/Detailsofwarehouseadjustment",
          state:{
              commission:commission,
              businessTimeStr:businessTimeStr,
              confirmTimeStr:confirmTimeStr,
              tradeRequestId:tradeRequestId,
            }
          });
      }else if(businessType === "T888"){ //调仓
        hashHistory.push({
          pathname:"/Detailsofwarehouseadjustment",
          state:{
              commission:commission,
              businessTimeStr:businessTimeStr,
              confirmTimeStr:confirmTimeStr,
              tradeRequestId:tradeRequestId,
            }
          });
      }else if(businessType === "TC24"){ //服务费
        hashHistory.push({
          pathname:"/Servicechargerecord",
          state:{
              tradeRequestId:tradeRequestId,
            }
          });
      }else{ //其他
        hashHistory.push({
          pathname:"/TransactionDetail",
          state:{
            data:data,
            flag:"JL",
            canCancel:false,
            title:"交易详情",
            commission: commission
            }
          });
      }
  }
  getNum(num1,num2){
    if(num1 === null && num2 === null){
      return null
    }else if(num1 === null){
      return num2 + '元'
    }else if(num2 === null){
      return num1 + '元'
    }else if(num1 == num2){
      return num1 + '元'
    }else{
      return null
    }
  }
 
  fuwufei(){
      hashHistory.push({
        pathname:'/Fuwufei',
        state:{
          superFundCode:this.props.location.state.superFundCode,
        }
      })
  }
  render() {
    let {txt,timeAll,transactionAll } = this.state;

    return (
        <div className="container">
            <div className="NHeader_containerq">
        <div className="NHeader_wrapq">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">交易记录</div>
            <div className="NHeader_share">
              <div onClick={()=>{this.fuwufei()}}>服务费</div>
            </div>
          </div>
          <div className="jiaoyijilutoubuxz" >
              <div onClick={()=>this.selectLeft("类型")} className="jiaoyijilutoubuxzleixing">
                <div className="jiaoyijilutoubuxzleixing1" >
                <div className="jiaoyijilutoubuxzleixing2" >
                {
                        txt === "类型"  ?
                        <text  style={{color:'#fff',fontWeight:"bold"}}>
                        { this.state.transactionType}
                      </text>
                        :
                        <text  style={{color:'#fff'}}>
                        { this.state.transactionType}
                      </text>
                    }
           
                  {
                        txt === "类型"  ?
                        <div className="jiaoyijilutoubuxzleixing2kuai" style={{ backgroundColor: "rgba(182, 146, 113, 1)"}}></div>
                        :
                        <div className="jiaoyijilutoubuxzleixing2kuai" style={{backgroundColor:"transparent"}}></div>
                    }
                </div>
                <div className="jiaoyijilutoubuxzleixing3" >
                </div>
                </div>
              </div>
              <div onClick={()=>this.selectRight("时间")}  className="jiaoyijilutoubuxzleixing"  >
                <div  className="jiaoyijilutoubuxzleixing1" >
                <div  className="jiaoyijilutoubuxzleixing2"  >
               {
                        txt === "时间"  ?
                        <text  style={{color:'#fff',fontWeight:"bold"}}>
                        { this.state.period}
                      </text>
                        :
                        <text  style={{color:'#fff'}}>
                        { this.state.period}
                      </text>
                    }
           
                  {
                        txt === "时间"  ?
                        <div className="jiaoyijilutoubuxzleixing2kuai" style={{backgroundColor: "rgba(182, 146, 113, 1)"}}></div>
                        :
                        <div className="jiaoyijilutoubuxzleixing2kuai"  style={{backgroundColor:"transparent"}}></div>
                    }
                </div>
                <div className="jiaoyijilutoubuxzleixing3" >
                </div>
                </div>
              </div>
            </div> 
        </div>
      </div>
      {this.state.totalDataArr.length===0 ? 
            null:
          <div className="ListViewWrap1">
          <ListView
            ref={el => this.lv = el}
            dataSource={this.state.dataSource}
            renderFooter={()=> this.renderFooter() }
            renderRow={(item, index)=>{
              objArr = [{createDate: ""}].concat(this.state.totalDataArr);
              return(
                <div onClick={()=>this.detailPush(item.annualizedGains,item.dividendMethod,item.confirmVolume,item.confirmAmount,item.redeemRate,item.commission,item.trustChannelName,item.fundName,item.superFundName,item.confirmTimeStr,item.businessTimeStr,item.applicationAmount,item.tradeRequestId,item.businessType)} className="jiaoyjiluliebiaozhanshi">
                <div className="jiaoyjiluliebiaozhanshitu" >
                    <img  className="jiaoyjiluliebiaozhanshitu1" src={require('../../imgs/icondfenhong.png')} />
                </div>
                <div className="jiaoyjiluliebiaozhanshiright">
                  <div className="jiaoyjiluliebiaozhanshiright1" >
                  <div className="jiaoyjiluliebiaozhanshiright1top" >
                    <div className="jiaoyjiluliebiaozhanshiright1topleft">
                    {item.businessType ==="T999"||item.businessType ==="T888" || item.businessType =='T031' ||item.businessType =='TC24'|| item.businessType == "T024" || item.businessType == "TA24" || item.businessType == "TF24"||item.businessType == "T522" || item.businessType == "T822" || item.businessType == "T422"|| item.businessType =="TH22" ?
                      <div >
                        {item.businessType ==="T999" ?
                          <div className="jiaoyjiluliebiaozhanshiright1topleftziti" >{item.businessTypeName.slice(4,6)}-{item.trustChannelName}</div>
                        :null
                        }
                        {item.businessType ==="T888" ?
                          <div className="jiaoyjiluliebiaozhanshiright1topleftziti" >{item.businessTypeName.slice(3,5)}-{item.trustChannelName}</div>
                        :null
                        }
                        {item.businessType ==="T031" ?
                          <div className="jiaoyjiluliebiaozhanshiright1topleftziti" >{item.businessTypeName}-{item.trustChannelName}</div>
                        :null
                        }
                        {item.businessType ==="TC24" ?
                          <div className="jiaoyjiluliebiaozhanshiright1topleftziti" >收取服务费-{item.trustChannelName}</div>
                        :null
                        }
                        {item.businessType === "T522" || item.businessType === "T822" || item.businessType === "T422"|| item.businessType ==="TH22"?
                          <div className="jiaoyjiluliebiaozhanshiright1topleftziti" >转入</div>
                        :null
                        }
                        {item.businessType === "T024" || item.businessType === "TA24" || item.businessType === "TF24"?
                          <div className="jiaoyjiluliebiaozhanshiright1topleftziti" >转出</div>
                        :null
                        }
                      </div>
                        :
                      <div>
                    <text>
                    {item.businessTypeName}
                    </text>
                     </div>
                    }
                    {/* { item.businessType === "T999" ?
                        <div className="jiaoyjiluliebiaozhanshiright1toplefttiaocang" >
                         平衡调仓
                        </div>:null
                    } */}
                     { item.businessType === "T888" ?
                        <div className="jiaoyjiluliebiaozhanshiright1toplefttiaocangzaitiaocang" >
                         再平衡调仓
                        </div>:null
                    }
                    </div>
                    <div className="jiaoyjiluliebiaozhanshiright1topright" >
                      {item.businessType === "T031" ?
                      <div >
                        {
                          item.dividendMethod === "0" ?
                          <text>
                          {
                         item.confirmVolume === null? "--" :item.confirmVolume + '份'
                          }
                          </text>:
                             <text>
                             {
                            item.confirmAmount === null?  "--":item.confirmAmount + '元'
                             }
                             </text>
                        }
                      </div>
                          :
                          <div>
                            {
                             item.redeemRate ===null ?
                             <text>
                             {
                              this.getNum(item.applicationAmount,item.applicationVolume)
                             }
                             </text>:
                                <text>
                                {
                               item.redeemRate === null?  "--": parseFloat((item.redeemRate*100).toPrecision(12))+ "%"
                                }
                                </text>
                            }
                       
                          </div>
                          
                      }
                    </div>
                  </div>
                  <div className="jiaoyjiluliebiaozhanshiright1bottom" >
                    <div className="jiaoyjiluliebiaozhanshiright1bottomleft" >
                    { item.businessType === "T031" || item.businessType ==="TC24" ?
                      <div>
                        {item.businessType === "T031" ?
                        <div className="jiaoyjiluliebiaozhanshiright1bottomleftziti" >
                        {item.fundName}({item.superFundName})
                        </div>
                       :
                       <text>
                       {item.superFundName}
                       </text>
                        }
                      </div>
                        :
                        <text>
                        {item.fundName}
                        </text>
                      }
                    </div>
                    <div className="jiaoyjiluliebiaozhanshiright1bottomright" style={{alignItems: "flex-end",display: "flex"}}>
                      {item.taConfirmStateName === "成功" ?
                        <text >
                        { 
                          item.taConfirmStateName
                        }
                        </text>
                      :
                      <text  style={{color:'#B69271'}}>
                      { 
                        item.taConfirmStateName
                      }
                      </text>
    
                      }
                     
                    </div>
                  </div>
                  </div>
                  <div className="jiaoyjiluliebiaozhanshiright2">
                      {
                        item.businessTimeStr
                      }
                  </div>
                </div>
              </div>
              )
            }}
            onEndReached={this.getSource}
            onEndReachedThreshold={0.1}
          />
        </div>
      }

          { timeAll?
          <DownUpList1  titleItem = '时间' cancelCallback = {()=>{this.setState({timeAll: false})}} chulihanshu={this.timeTypeCallback.bind(this)}   listContent = {[
            {title: '全部时间', callback:('全部时间',"")},
            {title: '今年以来', callback:('今年以来',"thisYear")},
            {title: '近一个月', callback:('近一月',"m1")}, 
            {title: '近三个月', callback:('近三月',"m3")}, 
            {title: '近六个月', callback:('近六月',"m6")}, 
            {title: '近一年', callback:('近一年',"y1")},
            {title: '近三年', callback:('近三年',"y3")},
          ]} />
          :null
        } 
          { transactionAll?
            <DownUpList1 titleItem = '交易' cancelCallback = {()=>{this.setState({transactionAll: false})}} chulihanshu={this.jyTypeCallback.bind(this)}  listContent = {[
              {title: '全部类型', callback: ('全部类型','')},
              {title: '转入', callback:('转入','T022')},
              {title: '转出', callback: ('转出','T024') },
              {title: '调仓', callback:('调仓','T999') },
              {title: '分红', callback:('分红','T031') }, 
              {title: '收取服务费', callback:('收取服务费','TC24')}, 
              {title: '其他', callback: ('其他','TB24') },
            ]} />
            :null
          }
          </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords:state.QueryTradeRecords
  }
}

export class DownUpList1 extends Component{
  constructor(props){
    super(props);
    this.state = {
      totalDataArr:[],
      timeAll:false,
      periodType: "",
      businessType:"",
    }
  }
  render(){
    let listContent = this.props.listContent;
    let listArray = [];
    for(let i = 0 ; i < listContent.length; i++){
      listArray.push(
        <div key = {i} className="contentContainer" onClick = {()=>this.props.chulihanshu(listContent[i].title, listContent[i].callback) } >
              <div  style = {{color:"#333333"}} >{listContent[i].title}</div>
        </div>
      )
    }
    return (
      <div className="container1">
           <div className="scrollView">
            {
              listArray
            }
          </div>
        <div style = {{flex:1}}  onClick = {this.props.cancelCallback}>
        </div>
       
      </div>
    );
  }
}
const styles = {  
  container: {  
    flex: 1,  
    backgroundColor:'#fff'
  },
  footerBox:{
    height: 30,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor:'#FFF',
    marginTop:-1
  }
 
};


export default connect(mapStateToProps)(Transactionrecordztgz);



// WEBPACK FOOTER //
// ./src/components/fundDetail/Transactionrecordztgz.js